<template>
  <div>
    <Breadcrumbs :title="title ? ('SMARTracs for ' + title) : ''"></Breadcrumbs>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <Loading v-if="loading" style="height: 800px" />

          <div v-else class="row">
            <div v-if="tracData && !tracData.length" class="card not-found-data">
              <img src="../../assets/images/not-found-img.jpg" alt="">
              <h4>Client has not enrolled in a SMARTrac</h4>
            </div>
            <div v-else class="col-md-6" v-for="(trac, index) in tracData" :key="index">
              <div class="card">
                <div class="blog-box blog-list row mr-0 ml-0">
                  <div class="col-sm-5">
                    <img v-if="trac.coverImageUrl" @error="imageLoadError(trac.id)" :src="trac.coverImageUrl" alt="Ontrac" class="img-fluid sm-100-w">
                    <img v-else src="../../assets/images/default-img.jpg" class="img-fluid sm-100-w" alt="">
                  </div>
                  <div class="col-sm-7">
                    <div class="blog">
                      <h6>{{trac.title}}</h6>
                      <div class="blog-bottom-content">
                        <ul class="blog-social">
                          <li> Category: {{trac.aspiration}}</li>
                          <li class="digits mt-3">
                            <router-link tag="button" :to="{ name: 'user-tracs', params: { tracId: trac.id, clientId: clientId } }" v-b-tooltip.hover title="See Goal" class="btn btn-primary mr-3">View Details</router-link>
                          </li>
                        </ul>
                        <hr>
                        <p class="mt-0">{{trac.briefDescription}}</p></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from "../../components/bread_crumbs";
  import Loading from "../../components/loading";
  import moment from "moment"

  export default {
    name: "user-trac",
    components: {
      Breadcrumbs,
      Loading
    },
    props: {
      userId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        tracImage: '',
        loadingBtn: false,
        loadingBtnEdit: false,
        tracData: [],
        imageData: '',
        loading: true,
        submitted: false,
        submittedEdit: false,
        aspiration_data: [],
        title: "",
        clientId: {
          type: String,
          default: ""
        }
      }
    },
    methods: {
      getTracs() {
        this.loading = true;
        this.$store.dispatch('getReferralsById', this.$route.params.id).then((val) => {
          this.title = val.data.result.firstName
        });
        this.$store.dispatch('getTracByUserId', this.$route.params.id).then(() => {
          this.tracData = this.$store.state.trac;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      moment(date) {
        return `<span>${moment(date).format('D')}</span> ${moment(date).format('MMMM')} ${moment(date).format('YYYY')}`
      },
      imageLoadError(id) {
        for (const [key, value] of Object.entries(this.tracData)) {
          if (value.id === id) {
            value.key = key;
            value.coverImageUrl = require('../../assets/images/default-img.jpg')
          }
        }
      }
    },
    mounted() {
      this.getTracs();
      this.clientId = this.$route.params.id;
    }
  }
</script>

<style scoped lang="scss">
  .blog-details {
    padding: 40px 0;
  }

  .blog-list img {
    padding: 17px 0;
  }

  .custom-select {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .tracImage-label {
    position: relative;

    i {
      position: absolute;
      background-color: #fff;
      color: #000;
      padding: 10px;
      margin: 10px;
      bottom: 0;
      right: 0;
      font-size: 20px;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .not-found-data {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
  }

  @media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {
    .blog-bottom-content {
      display: block !important;
    }
  }
</style>
